/**
 * The front door.
 *
 * Microsoft, and nothing else. ADR-0014 and `core/identity/provider.py` refuse a
 * second authentication path — "a second thing to attack and a second thing to
 * forget to disable" — so there is no password field to omit by accident, and
 * the card says as much rather than leaving a person to wonder.
 *
 * The brand lockup is the shipped wordmark rather than initials in a tile,
 * matching `AppShell` and its reason: "The wordmark the brand system ships, not
 * an initial in a box."
 *
 * State arrives as props, not from the URL. The component is then renderable
 * without a router, and the one place that decides which state applies is
 * `App.tsx`.
 */

import { signIn } from "../api/client";

export type LoginNotice = "signed-out" | "expired";

export interface LoginProps {
  /** Where the person was trying to go, so sign-in returns them there. */
  returnPath?: string | undefined;
  /** What to say above the button, if anything. */
  notice?: LoginNotice | undefined;
}

const NOTICES: Record<LoginNotice, string> = {
  "signed-out": "You've been signed out.",
  expired: "Your session ended. Sign in again.",
};

export function Login({ returnPath, notice }: LoginProps) {
  return (
    <main className="nx-login">
      <div className="nx-login__card">
        <div className="nx-login__brand">
          <img
            className="nx-login__wordmark"
            src="/brand/taevas-wordmark-white.png"
            alt="Taevas"
          />
          <span className="nx-login__product">Nexus Platform</span>
        </div>

        {notice ? (
          <p className="nx-login__notice" role="status">
            {NOTICES[notice]}
          </p>
        ) : null}

        <button className="nx-login__button" type="button" onClick={() => signIn(returnPath)}>
          Sign in with Microsoft
        </button>

        <p className="nx-login__note">Your Taevas account is the only way in.</p>
      </div>
    </main>
  );
}
